import { Outlet } from 'react-router';
import { NavLink } from 'react-router-dom';

import gearbeltSquareLogo from '@/assets/gearbelt-square.svg';
import sitemateStartSquareLogo from '@/assets/sitemate-start-square.svg';
import { cn } from '@/lib/utils';
import { getWorkspaceRoute } from '@/utils/routes';

function SettingsPage() {
  return (
    <div className="flex h-full justify-center gap-4 p-6">
      <SettingsNavigation />
      <Outlet />
    </div>
  );
}

function SettingsNavigation() {
  return (
    <div className="flex w-[180px] shrink-0 flex-col gap-2">
      <div className="flex w-full flex-col text-sm">
        <div className="flex items-center gap-1 py-2">
          <img src={gearbeltSquareLogo} alt="Gearbelt Logo" /> <span className="font-medium">Workspace Settings</span>
        </div>
        <div className="flex w-full flex-col gap-2">
          {getWorkspaceSettingsTabs().map((tab, idx) => (
            <NavLink
              className={({ isActive }) =>
                cn('bg-grey-2 text-secondary-text flex w-full gap-2 rounded-md p-2 font-medium', isActive && 'bg-default-light-blue text-default-blue')
              }
              to={tab.route}
              key={idx}>
              {tab.name}
            </NavLink>
          ))}
        </div>
      </div>

      <div className="flex w-full flex-col pb-6 text-sm">
        <div className="flex items-center gap-1 py-2">
          <img src={sitemateStartSquareLogo} alt="Sitemate Start Logo" /> <span className="font-medium">Sitemate Start</span>
        </div>
        <div className="flex w-full flex-col gap-2">
          {getSitemateStartSettingsTabs().map((tab, idx) => (
            <NavLink
              className={({ isActive }) =>
                cn('bg-grey-2 text-secondary-text flex w-full gap-2 rounded-md p-2 font-medium', isActive && 'bg-default-light-blue text-default-blue')
              }
              to={tab.route}
              key={idx}>
              {tab.name}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}

const getWorkspaceSettingsTabs = () => [
  {
    id: 'workspace-general',
    name: 'General',
    route: getWorkspaceRoute('/settings/workspace/general'),
  },
  {
    id: 'workspace-branding',
    name: 'Branding',
    route: getWorkspaceRoute('/settings/workspace/branding'),
  },
  {
    id: 'workspace-notifications',
    name: 'Notifications',
    route: getWorkspaceRoute('/settings/workspace/notifications'),
    hasSubView: true,
  },
  {
    id: 'workspace-feature-access',
    name: 'Feature Access',
    route: getWorkspaceRoute('/settings/workspace/feature-access'),
  },
  {
    id: 'workspace-issues',
    name: 'Issues',
    route: getWorkspaceRoute('/settings/workspace/issues'),
  },
  {
    id: 'workspace-documents',
    name: 'Documents',
    route: getWorkspaceRoute('/settings/workspace/documents'),
  },
  {
    id: 'workspace-work-orders',
    name: 'Work Orders',
    route: getWorkspaceRoute('/settings/workspace/work-orders'),
  },
  { id: 'schedules', name: 'Schedules', route: getWorkspaceRoute('/settings/workspace/schedules') },
];

const getSitemateStartSettingsTabs = () => [
  {
    id: 'sitemate-start-general',
    name: 'General',
    route: getWorkspaceRoute('/settings/sitemate-start/general'),
  },
  {
    id: 'sitemate-start-global-billing',
    name: 'Global Billing',
    route: getWorkspaceRoute('/settings/sitemate-start/billing'),
  },
  {
    id: 'sitemate-start-gearbelt-billing',
    name: 'Gearbelt Billing',
    route: getWorkspaceRoute('/settings/sitemate-start/gearbelt-billing'),
  },
  {
    id: 'sitemate-start-security',
    name: 'Security',
    route: getWorkspaceRoute('/settings/sitemate-start/security'),
  },
];

export default SettingsPage;
